import { cn } from '@/utils'
import { useMemo } from 'react'

type TimeDisplayProps = {
  hours: number
  minutes: number
  seconds: number
}

function padTimeUnit(num: number): string {
  return num.toString().padStart(2, '0')
}

export function TimeDisplay({ hours, minutes, seconds }: TimeDisplayProps) {
  const units = useMemo(
    () => [
      { value: hours, label: 'h' },
      { value: minutes, label: 'm' },
      { value: seconds, label: 's' },
    ],
    [hours, minutes, seconds],
  )

  const firstActiveIdx = useMemo(() => {
    const firstNonZeroIdx = units.findIndex((u) => u.value !== 0)
    return firstNonZeroIdx === -1 ? units.length - 1 : firstNonZeroIdx
  }, [units])

  return (
    <span className="flex items-center gap-1">
      {units.map(({ label, value }, idx) => (
        <TimeUnit
          key={label}
          value={value}
          label={label}
          isDimmed={idx < firstActiveIdx}
        />
      ))}
    </span>
  )
}

type TimeUnitProps = {
  value: number
  label: string
  isDimmed: boolean
}
function TimeUnit({ value, label, isDimmed }: TimeUnitProps) {
  return (
    <div
      className={cn(
        'transition-opacity ease-in-out duration-200',
        'tabular-nums',
        isDimmed ? 'opacity-40' : 'opacity-100',
      )}
    >
      <span>{padTimeUnit(value)}</span>
      <span>{label}</span>
    </div>
  )
}
